module.exports = __webpack_public_path__ + "static/scale-model-of-oakland-california-359c7943dd25b26ff20fc6a526b2221f.png";